import React, { useEffect, useRef, useState } from "react";
import {
  LoadingWrapper,
  LoaderContainer,
  LoaderTextContainer,
  LoaderText,
} from "../styles/components/loader";
import animations from "../animations/animations";

const Loader = ({ content, handleLoaded }) => {
  const [hasMounted, setHasMounted] = useState(false);
  const [shouldRender, setShouldRender] = useState(true);
  const [fakeProgress, setFakeProgress] = useState(0);

  const wrapperRef = useRef(null);
  const loaderTextRef = useRef(null);

  const articleData = content.find(item => item.key === "article--data");
  const primaryColor = articleData?.colors?.primary;
  const secondaryColor = articleData?.colors?.secondary;
  const articleId = parseFloat(articleData?.id);

  const toggleScroll = state => {
    const element =
      document.querySelector("#hs-web") || document.querySelector("#hs-app");
    if (element) {
      element.style.overflow = state;
    } else {
      document.body.style.overflow = state;
    }
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (!hasMounted) return;

    window.scrollTo(0, 0);
    toggleScroll("hidden");
  }, [hasMounted]);

  useEffect(() => {
    if (!hasMounted) return;
    let progress = 0;

    const animateCount = () => {
      progress += (100 - progress) * 0.025;

      if (progress >= 99.5) {
        setFakeProgress(100);
        animations
          .timeline({
            onStart: () => {
              handleLoaded(true);
            },
            onComplete: () => {
              toggleScroll("unset");
              setTimeout(() => setShouldRender(false), 500);
            },
          })
          .to(
            loaderTextRef.current,
            {
              delay: 0.5,
              yPercent: 100,
              opacity: 0,
              duration: 0.5,
            },
            0
          )
          .to(wrapperRef.current, {
            delay: 0,
            opacity: 0,
            duration: 0.25,
          });

        return;
      }

      setFakeProgress(Math.floor(progress));
      requestAnimationFrame(animateCount);
    };

    setTimeout(() => {
      requestAnimationFrame(animateCount);
    }, 0);
  }, [hasMounted]);

  return shouldRender ? (
    <LoadingWrapper ref={wrapperRef} $backgroundColor={secondaryColor}>
      <LoaderContainer>
        <LoaderTextContainer>
          <LoaderText
            ref={loaderTextRef}
            $fontColor={primaryColor}
            $articleId={articleId}
            suppressHydrationWarning={true}
          >
            {hasMounted ? fakeProgress : 0}
          </LoaderText>
        </LoaderTextContainer>
      </LoaderContainer>
    </LoadingWrapper>
  ) : null;
};

export default Loader;
